import { NO_WRAP } from 'wix-rich-content-common';
import { Node_Type } from 'ricos-types';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const LINE_SINGLE = "single";
const LINE_DOUBLE = "double";
const ALIGN_CENTER = "center";
const SIZE_LARGE = "large";
const DEFAULTS = Object.freeze({
  type: LINE_SINGLE,
  config: {
    size: SIZE_LARGE,
    alignment: ALIGN_CENTER,
    textWrap: NO_WRAP
  }
});

const DIVIDER_TYPE = "wix-draft-plugin-divider";

var dividerStyles = {"divider-container":"_4-MIc","divider-container--double":"n-TYx","divider":"B70rH","divider--single":"_3JsO2","divider--double":"mq7kN","divider--dashed":"bM4B9","divider--dotted":"S8tb-","divider--small":"hmDFr","divider--small--mobile":"J-z1l","divider--medium":"zzQ4C","divider--large--mobile":"-pM6s","divider--medium--mobile":"ca3ce","divider--large":"Athvf","divider--left":"_6piUK","divider--center":"D8R-x","divider--right":"TdE1T","divider--fill-parent":"-Ap85","svgFixerContainer":"pFxyb","emptyChar":"Ia90Q"};

const withSafariSvgCaretFixer = (Component) => /* @__PURE__ */ React.createElement("div", { className: dividerStyles.svgFixerContainer }, Component, /* @__PURE__ */ React.createElement("div", { className: dividerStyles.emptyChar }, "\xA0"));

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const lineProps = (width, lineDistance = 1) => ({
  x2: width,
  y1: lineDistance,
  y2: lineDistance
});
const getLines = (type, width, multilineDistance = 7) => {
  const linePropsArr = [lineProps(width)];
  if (type === LINE_DOUBLE) {
    linePropsArr.push(lineProps(width, multilineDistance));
  }
  return linePropsArr;
};
const DividerLine = ({
  type,
  size,
  alignment,
  width,
  multilineDistance,
  styles,
  className,
  fillParent,
  isMobile
}) => {
  const linesPropsArr = getLines(type, width, multilineDistance);
  const lineClassName = classNames(
    styles.divider,
    styles[`divider--${type}`],
    styles[`divider--${size}${isMobile ? "--mobile" : ""}`],
    styles[`divider--${alignment}`],
    fillParent ? styles["divider--fill-parent"] : "",
    className
  );
  return withSafariSvgCaretFixer(
    /* @__PURE__ */ React.createElement("svg", { className: lineClassName }, linesPropsArr.map((lineProp, i) => /* @__PURE__ */ React.createElement("line", __spreadValues$1({ key: i }, lineProp))))
  );
};
DividerLine.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  alignment: PropTypes.string,
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  multilineDistance: PropTypes.number,
  fillParent: PropTypes.bool,
  isMobile: PropTypes.bool
};
var DividerLine$1 = DividerLine;

const ROOT = "divider";

const DividerViewer = ({ componentData }) => {
  var _a, _b, _c;
  const { isMobile } = useContext(RicosContext);
  const lineStyle = (_a = componentData.lineStyle) == null ? void 0 : _a.toLowerCase();
  const className = classNames(
    dividerStyles["divider-container"],
    dividerStyles[`divider-container--${lineStyle}`],
    isMobile && dividerStyles["divider-container--mobile"]
  );
  return /* @__PURE__ */ React.createElement("div", { className, "data-hook": `${ROOT} divider-${lineStyle}` }, /* @__PURE__ */ React.createElement(
    DividerLine$1,
    {
      type: lineStyle,
      width: "100%",
      size: (_b = componentData.width) == null ? void 0 : _b.toLowerCase(),
      alignment: (_c = componentData.alignment) == null ? void 0 : _c.toLowerCase(),
      styles: dividerStyles,
      isMobile
    }
  ));
};

const Divider = ({ node, nodeIndex, NodeViewContainer }) => {
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(DividerViewer, { componentData: node.dividerData }));
};

const nodeViewRenderers = {
  [Node_Type.DIVIDER]: Divider
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginDivider = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: DIVIDER_TYPE,
    nodeViewRenderers
  };
};

export { DIVIDER_TYPE, pluginDivider };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-divider/dist/es/styles.viewer.min.global.css'